import { Reveal } from "./Reveal";
import { Divider, Monogram } from "./Ornaments";
import { COUPLE, IMAGES } from "./data";

const InvitationLetter = () => (
    <section
        id="invitation"
        data-testid="invitation-section"
        className="relative overflow-hidden py-24 sm:py-36"
    >
        <div
            className="pointer-events-none absolute -right-40 top-1/2 h-[480px] w-[480px] -translate-y-1/2 rounded-full opacity-[0.07]"
            style={{
                backgroundImage: `url(${IMAGES.decor[0]})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            aria-hidden="true"
        />

        <div className="mx-auto max-w-4xl px-6">
            <Reveal className="flex justify-center">
                <Monogram className="h-20 w-20" />
            </Reveal>

            <Reveal delay={0.1}>
                <p className="mt-10 text-center font-cinzel text-[11px] font-semibold uppercase tracking-[0.5em] text-gold">
                    The Invitation
                </p>
            </Reveal>

            <Reveal delay={0.2}>
                <h2 className="mt-6 text-balance text-center font-royal text-2xl font-medium leading-relaxed text-ivory sm:text-3xl lg:text-4xl">
                    With immense joy and happiness,
                    <span className="mt-2 block text-sand">
                        <span className="font-semibold text-gold">Smt. Alka Alagh</span> &amp;{" "}
                        <span className="font-semibold text-gold">Shri Sunil Kumar Alagh</span>
                    </span>
                    <span className="mt-4 block text-xl italic text-sand sm:text-2xl">
                        request your gracious presence to celebrate the wedding of their son
                    </span>
                </h2>
            </Reveal>

            <Reveal delay={0.3}>
                <div className="mt-14 grid items-center gap-10 sm:grid-cols-[1fr_auto_1fr]">
                    <div className="text-center sm:text-right">
                        <p className="gold-shimmer animate-shimmer-sweep font-script text-5xl sm:text-6xl">
                            {COUPLE.groom}
                        </p>
                        {COUPLE.groomLineage.map((line) => (
                            <p key={line} className="mt-3 font-cinzel text-[10px] uppercase tracking-[0.25em] text-mutedgold sm:text-[11px]">
                                {line}
                            </p>
                        ))}
                    </div>
                    <Divider className="mx-auto rotate-90 sm:rotate-0 sm:flex-col sm:gap-6" />
                    <div className="text-center sm:text-left">
                        <p className="gold-shimmer animate-shimmer-sweep font-script text-5xl sm:text-6xl">
                            {COUPLE.bride}
                        </p>
                        {COUPLE.brideLineage.map((line) => (
                            <p key={line} className="mt-3 font-cinzel text-[10px] uppercase tracking-[0.25em] text-mutedgold sm:text-[11px]">
                                {line}
                            </p>
                        ))}
                    </div>
                </div>
            </Reveal>

            <Reveal delay={0.4}>
                <Divider className="mt-16" label="॥ श्री गणेशाय नमः ॥" />
            </Reveal>

            <Reveal delay={0.5}>
                <p className="mx-auto mt-12 max-w-2xl text-center font-royal text-lg italic leading-relaxed text-sand sm:text-xl">
                    Your gracious presence and blessings will make our celebration truly memorable.
                    Two families, one blessing — we await you with open hearts in New Delhi this
                    November.
                </p>
            </Reveal>
        </div>
    </section>
);
export default InvitationLetter;
